import { useBreadcrumbItem } from '@framework/ui/core/router/breadcrumbs/BreadcrumbContext.tsx';
import { PageLayout } from '../../ui/layout/PageLayout.tsx';
import { LoginForm } from './component/LoginForm.tsx';

export interface ILoginPageProps {}

export function LoginPage(props: ILoginPageProps) {
  // Aggiunge il breadcrumb
  // l'informazione viene utilizzata anche per nascondere il pulsante di login
  useBreadcrumbItem({
    path: '/login',
    title: 'Login',
  });

  return (
    <PageLayout>
      <LoginForm />
    </PageLayout>
  );
}
